import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @internal
 */
export const CarbonDocumentUnknown = (props) => {
    return (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 32 32", role: "presentation", ...props, children: [_jsx("circle", { cx: "9", cy: "28.5", r: "1.5", fill: "currentColor" }), _jsx("path", { fill: "currentColor", d: "M10 25H8v-4h2a2 2 0 0 0 0-4H8a2.002 2.002 0 0 0-2 2v.5H4V19a4.005 4.005 0 0 1 4-4h2a4 4 0 0 1 0 8Z" }), _jsx("path", { fill: "currentColor", d: "m27.7 9.3l-7-7A.908.908 0 0 0 20 2H10a2.006 2.006 0 0 0-2 2v8h2V4h8v6a2.006 2.006 0 0 0 2 2h6v16H14v2h12a2.006 2.006 0 0 0 2-2V10a.91.91 0 0 0-.3-.7ZM20 10V4.4l5.6 5.6Z" })] }));
};
/**
 * @internal
 */
export const CarbonDocumentAudio = (props) => {
    return (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 32 32", role: "presentation", ...props, children: [_jsx("path", { fill: "currentColor", d: "M29 31a.999.999 0 0 1-.625-.22L23.65 27H20a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h3.65l4.726-3.78A1 1 0 0 1 30 17v13a1 1 0 0 1-1 1Zm-8-6h3a1 1 0 0 1 .625.22L28 27.92v-8.84l-3.376 2.7A1 1 0 0 1 24 22h-3Z" }), _jsx("path", { fill: "currentColor", d: "M16 28H8V4h8v6a2.006 2.006 0 0 0 2 2h6v3h2v-5a.91.91 0 0 0-.3-.7l-7-7A.909.909 0 0 0 18 2H8a2.006 2.006 0 0 0-2 2v24a2.006 2.006 0 0 0 2 2h8Zm2-23.6l5.6 5.6H18Z" })] }));
};
/**
 * @internal
 */
export const CarbonPauseFilled = (props) => {
    return (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 32 32", role: "presentation", ...props, children: _jsx("path", { fill: "currentColor", d: "M12 6h-2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm10 0h-2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z" }) }));
};
/**
 * @internal
 */
export const CarbonPlayFilledAlt = (props) => {
    return (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 32 32", role: "presentation", ...props, children: _jsx("path", { fill: "currentColor", d: "M7 28a1 1 0 0 1-1-1V5a1 1 0 0 1 1.482-.876l20 11a1 1 0 0 1 0 1.752l-20 11A1 1 0 0 1 7 28Z" }) }));
};
//# sourceMappingURL=icons.js.map